import store from '@/store/store'
import moment from 'moment'
import { payload as batchActionPayload } from '@/components/RouteComponents/Batches/actionPayload'

export class UserBatchGenerator {

  constructor (actionPayloads) {
    this.actionPayloads = actionPayloads || []
  }

  /**
   * Generates a user batch name
   * @return {string}
   */
  static getUserBatchName () {
    const setting = store.getters.getUiSettings['BATCH_HANDLING']
    switch (setting) {
      case 'username_mmddyyyy':
        return store.getters.getUser.username.substring(0, 8) + '_' + moment(new Date()).format('MMDDYYYY')
      case 'mmddyyyy_username':
        return moment(new Date()).format('MMDDYYYY') + '_' + store.getters.getUser.username.substring(0, 8)
      case 'username_yyyymmdd':
        return store.getters.getUser.username.substring(0, 8) + '_' + moment(new Date()).format('YYYYMMDD')
      default:
        return moment(new Date()).format('YYYYMMDD') + '_' + store.getters.getUser.username.substring(0, 8)
    }
  }

  /**
   * Checks the store to determine whether a user batch is cached
   * @return {object}
   */
  static checkIfUserBatchIsCached () {
    return store.getters.getAllBatches.find(batch => batch.name === this.getUserBatchName())
  }

  /**
   * Queries the API to determine if a user batch exists, based on the search criteria provided
   * @return {Promise<boolean>}
   */
  static async checkIfUserBatchExists () {
    const batchName = this.getUserBatchName()
    const newPayload = Object.assign({}, batchActionPayload, { query: { search: batchName, active: true } })
    try {
      const resp = await store.dispatch('fetchWithQuery', newPayload)
      let batches
      if (resp && resp.entities && resp.entities.batches) {
        batches = resp.entities.batches
      }
      return !!(batches && Object.keys(batches).length)
    } catch (e) {
      console.log(e)
      return false
    }
  }

  /**
   * Checks whether any of the required batch dependencies are missing, and fetches them if needed
   * @return {Promise<any[]>}
   */
  async checkForMissingDefaultModels () {
    try {
      let promises = []
      this.actionPayloads.forEach(payload => {
        if (!payload.defaultModelGetter) return
        if (!(payload.defaultModelGetter && payload.defaultModelGetter.id)) {
          const payloadWithQuery = Object.assign({}, payload, { query: { active: true } })
          promises.push(store.dispatch('fetchWithQuery', payloadWithQuery))
        }
      })
      return await Promise.all(promises)
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * Generates a user system batch
   * @return {Promise<void>}
   */
  async generateUserBatch () {
    try {
      await this.checkForMissingDefaultModels()
      const { getUser } = store.getters
      let data = {
        name: this.constructor.getUserBatchName(),
        active: true,
        description: 'System-generated batch',
        user: getUser.userId
      }
      this.actionPayloads.forEach(payload => {
        if (!(payload.moduleName && payload.defaultModelGetter && store.getters[payload.defaultModelGetter].id)) return
        data[payload.moduleName] = store.getters[payload.defaultModelGetter].id
      })
      const newPayload = Object.assign({}, batchActionPayload, { data })
      await store.dispatch('save', newPayload)
    } catch (e) {
      console.log(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/DataEntryViews/UserBatchGenerator.js